<template>
    <SidebarPanel
        :is-open="ui.flashcardsPanel.opened"
        :title="localizations[lang].flashcards"
        side="left"
        persistent
        mobile-fullscreen
        resizable
        :fullscreen="flashcardStudyMode.isFullscreen"
        @close="onClose"
    >
        <ReaderFlashcards />
    </SidebarPanel>
</template>

<script>
'use strict';

import { mapActions, mapMutations, mapState } from 'vuex';
import ReaderFlashcards from './ReaderFlashcards.vue';
import SidebarPanel from '../Components/SidebarPanel.vue';

export default {
    name: 'ReaderFlashcardsPanel',
    components: {
        ReaderFlashcards,
        SidebarPanel,
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'flashcardStudyMode']),
    },
    methods: {
        ...mapActions(['toggleFlashcardsPanel', 'endStudyMode']),
        ...mapMutations(['closeFlashcardForm']),
        // The close button, Escape and back all land here. Studying and the card form sit
        // one level in, like a piece over the add-ons list, so they return to the cards
        // before the panel closes, the form dropping what it holds as Cancel does.
        onClose() {
            if (this.ui.flashcardsPanel.form) this.closeFlashcardForm();
            else if (this.flashcardStudyMode.active) this.endStudyMode();
            else this.toggleFlashcardsPanel();
        },
    },
};
</script>
